import { useLoaderData } from '@remix-run/react';

import CategorySection from './CategorySection';
import FeaturedSection from './FeaturedSection';

interface Props {
  isNewWebBuilder?: boolean;
  isExampleWebSite?: boolean;
  postsSection?: any;
  generalSection?: any;
}

const FeaturedSections = ({
  isNewWebBuilder = false,
  isExampleWebSite = false,
  postsSection,
  generalSection,
}: Props) => {
  const { featuredPosts, paginatedPosts } = useLoaderData<any>();
  const isDefaultHeader = generalSection?.theme.header_type === 'default';

  return (
    <div className="mb-0 lg:mb-16">
      {isDefaultHeader && (
        <FeaturedSection
          title={postsSection.featured_sections.featured_posts_label}
          description={postsSection.featured_sections?.featured_posts_description}
          posts={featuredPosts}
          card={postsSection?.card}
          fontFamily={postsSection.featured_sections.font}
          isLoading={false}
          isNewWebBuilder={isNewWebBuilder}
        />
      )}
      {postsSection.featured_sections.latest_posts_enabled && (
        <FeaturedSection
          title={postsSection.featured_sections.latest_posts_label}
          description={postsSection.featured_sections?.latest_posts_description}
          posts={paginatedPosts.posts.slice(0, 3)}
          card={postsSection?.card}
          fontFamily={postsSection.featured_sections.font}
          isLoading={false}
          isNewWebBuilder={isNewWebBuilder}
        />
      )}
      {!isExampleWebSite &&
        postsSection.featured_sections.category_posts.map((category: any) => {
          return (
            <CategorySection
              key={category}
              category={category}
              fontFamily={postsSection.featured_sections.font}
              card={postsSection?.card}
              isNewWebBuilder={isNewWebBuilder}
            />
          );
        })}
    </div>
  );
};

export default FeaturedSections;
